import { Avatar } from '../../../component-lib/catalyst/avatar';

export default function UserDetails({ firstName, lastName, avatar, email, phoneNumber }) {
  return (
    <div className="p-4">
      <div className="border-b pb-2 mb-4 flex items-center gap-x-2">
        <Avatar
          src={avatar}
          initials={`${firstName[0]}${lastName[0]}`}
          className="size-6"
        />
        <div>{`${firstName} ${lastName}`}</div>
      </div>
      <p>{email}</p>
      <p>{phoneNumber}</p>
    </div>
  );
}
